import { z } from "zod";
import { email, nonEmpty, strongPassword, uuid } from "./_primitives";

export const loginSchema = z.object({
  email,
  password: z.string().min(1, "Password is required"),
});

export const acceptInviteSchema = z.object({
  token: nonEmpty,
  name: nonEmpty,
  password: strongPassword,
});

export const requestPasswordResetSchema = z.object({
  email,
});

export const resetPasswordSchema = z.object({
  token: nonEmpty,
  password: strongPassword,
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: strongPassword,
});

export type LoginInput = z.infer<typeof loginSchema>;
export type AcceptInviteInput = z.infer<typeof acceptInviteSchema>;
export type RequestPasswordResetInput = z.infer<typeof requestPasswordResetSchema>;
export type ResetPasswordInput = z.infer<typeof resetPasswordSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
